'use client';

import React from 'react';
import { PageProps } from '../../types/page';
import PageContent from '../../components/PageContent';
import { SchemeProvider } from '@osmosis/react-ui/context/SchemeContext';
import AppPageProviders from './AppPageProviders';
import StyledComponentsRegistry from '../registry';

type Props = PageProps;

/**
 * Wrap page content with app page provider.
 */
const AppPage = (props: Props) => {
  return (
    <StyledComponentsRegistry>
      <AppPageProviders {...props}>
        <SchemeProvider scheme={props.scheme || 'light'}>
          <PageContent {...props} />
        </SchemeProvider>
      </AppPageProviders>
    </StyledComponentsRegistry>
  );
};

export default AppPage;
